import { useSelector } from "react-redux"

const useRecoveries = ()=>{
    return useSelector(state => state.recoveries.data)
}

export default useRecoveries